/**
 * Formats a file size in bytes to a human-readable string
 * @example formatFileSize(0) // '0 Bytes'
 * @example formatFileSize(1024) // '1 KB'
 * @example formatFileSize(1536) // '1.5 KB'
 * @example formatFileSize(1048576) // '1 MB'
 */
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}
